export default __webpack_public_path__ + "static/media/PropostasCanceladas.32e422ff.svg";